// Bugsnag groups a handled notify by the minified code around the call, so each
// deploy split the checkout payment warnings into a fresh set of groups, and
// one group mixed unrelated Stripe failures (a lost connection next to a
// rejected intent). A fixed hash keeps one long-lived group per kind of
// failure: where it happened, what Stripe (or axios) called it, and the code.
export function checkoutGroupingHash(stage, type, code) {
  return ["checkout", stage, type || "unknown", code || "none"].join(":");
}
